import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ApiClass } from '@data/class/api-class'
import { IResponse, IResponseArray } from '@data/interfaces/iresponseArray.interface'
import { environment } from '@env/environment'
import { ITimelineFilters } from '../../interfaces/timeline-filters.interface'

@Injectable({ providedIn: 'root' })
export class ApiOmnichannelTimelineService extends ApiClass {
  constructor() {
    super()
    this.path = 'omnichannel'
  }

  getTimeline(clientId: string, filters: ITimelineFilters): Observable<IResponseArray> {
    const { page = 1, limit = 50, ...rest } = filters
    return this.http.post<IResponseArray>(`${environment.apiUrl}${this.path}/timeline/${clientId}`, { page, limit, ...rest })
  }

  //* clients/:id/assign-channel (PRD §7.3) — reasignación con motivo
  assignChannel(clientId: string, payload: { channelKey: string; reason?: string }): Observable<IResponse> {
    return this.http.post<IResponse>(`${environment.apiUrl}clients/${clientId}/assign-channel`, payload)
  }

  //* clients/:id/close (PRD §7.3) — cierre manual del funnel (caída pre-lease)
  closeClient(clientId: string, payload: { outcome: 'lost'; reason: string }): Observable<IResponse> {
    return this.http.post<IResponse>(`${environment.apiUrl}clients/${clientId}/close`, payload)
  }

  //* clients/:id/reactivate-funnel — reabre un cliente caído (lost) para nueva oportunidad → vuelve al funnel.
  //* Ruta distinta de clients/:id/reactivate (ese reactiva el ACCESO al portal, permiso clients.delete).
  reactivateClient(clientId: string): Observable<IResponse> {
    return this.http.post<IResponse>(`${environment.apiUrl}clients/${clientId}/reactivate-funnel`, {})
  }
}
